{
  "accept": "قبول کریں",
  "action": "Action",
  "allCountries": "تمام ممالک",
  "allPayments": "تمام Payments",
  "allTypes": "تمام اقسام",
  "amount": "رقم",
  "asset": "Asset",
  "buy": "خریدیں",
  "buyer": "خریدار",
  "cancel": "Cancel",
  "cancelFailed": "کینسل ناکام ہو گیا",
  "cancelled": "کینسلڈ",
  "completed": "مکمل",
  "country": "ملک",
  "createP2pAd": "P2P Ad بنائیں",
  "dispute": "تنازع",
  "disputeReason": "تنازع کی وجہ",
  "escrow": "Escrow",
  "escrowActive": "Escrow Active",
  "escrowProtection": "ایسکرو تحفظ",
  "escrowReady": "Escrow تیار ہے",
  "fillAllFields": "تمام fields پُر کریں",
  "global": "Global",
  "globalP2pTrading": "گلوبل P2P ٹریڈنگ",
  "inEscrow": "Escrow میں",
  "inTrade": "Trade میں",
  "liveGlobalAds": "Live Global Ads",
  "loading": "لوڈ ہو رہا ہے...",
  "markPaid": "Paid Mark کریں",
  "noP2pAdsFound": "کوئی P2P ad موجود نہیں۔",
  "offline": "Offline",
  "online": "Online",
  "open": "اوپن",
  "openDispute": "تنازع کھولیں",
  "orderCancelledRefunded": "Order cancel ہو گیا اور asset refund ہو گیا",
  "orderDetails": "آرڈر کی تفصیلات",
  "orderId": "آرڈر آئی ڈی",
  "p2pOrderCreated": "P2P order بن گیا",
  "p2pSecurity": "P2P Security",
  "p2pSecurity1": "✅ User-to-user trading",
  "p2pSecurity2": "✅ Live database orders",
  "p2pSecurity3": "✅ Escrow status tracking",
  "p2pSecurity4": "✅ Payment proof upload",
  "p2pSecurity5": "✅ Admin can review all",
  "p2pSecurity6": "✅ Safe P2P status flow",
  "p2pSubtitle": "محفوظ escrow protection کے ساتھ دنیا بھر میں crypto خریدیں اور بیچیں۔",
  "p2pTitle": "عالمی P2P ٹریڈنگ",
  "payment": "Payment",
  "paymentMethod": "ادائیگی کا طریقہ",
  "paymentProof": "ادائیگی کا ثبوت",
  "paymentSent": "Payment Sent",
  "paymentSubmitted": "Payment submit ہو گئی",
  "pleaseLoginFirst": "براہ کرم پہلے لاگ اِن کریں۔",
  "price": "قیمت",
  "processing": "پروسیسنگ ہو رہی ہے...",
  "release": "Release",
  "releaseFailed": "Release failed",
  "selectPaymentMethod": "Payment Method منتخب کریں",
  "sell": "فروخت کریں",
  "seller": "فروخت کنندہ",
  "serverError": "سرور میں خرابی۔",
  "sessionExpired": "سیشن ختم ہو گیا۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "status": "اسٹیٹس",
  "totalOrders": "کل آرڈرز",
  "tradeCompletedSuccessfully": "Trade کامیابی سے complete ہو گئی",
  "tradeFailed": "Trade failed",
  "tradeStartedSuccessfully": "Trade کامیابی سے start ہو گئی",
  "trader": "ٹریڈر",
  "unknownTrader": "تاجر",
  "uploadPaymentProof": "براہ کرم payment proof image upload کریں",
  "uploadProof": "ثبوت اپ لوڈ کریں",
  "verifiedMerchant": "Verified Merchant",
  "waitingEscrow": "Escrow کا انتظار",
  "walletAddress": "والٹ ایڈریس"
}